export class UtilsHelper {
    static createCopy<T>(obj:T) {
        return JSON.parse(JSON.stringify(obj)) as T;
    }
}
